import { instanceMapAPI, instanceMapReverseAPI } from "./axiosConfigMap";
const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export const getPlacesForText = async ({ text }) => {
  try {
    // const bboxMexico = [-118.3648, 14.5345, -86.7096, 32.7187];
    const encodeText = encodeURIComponent(text);
    const response = await instanceMapAPI.get(
      `forward?q=${encodeText}&language=es-MX&proximity=-99.4732879,19.3910844&country=MX&types=poi,address,street,place&access_token=${accessToken}`
    );
    return response.data?.features;
  } catch (error) {
    throw error;
  }
};

export const getPlaceForCoordinates = async (coordinates) => {
  try {
    const responsePlace = await instanceMapReverseAPI.get(
      `reverse?longitude=${coordinates[0]}&latitude=${coordinates[1]}&access_token=${accessToken}`
    );

    return responsePlace.data?.features[0]?.properties ?? undefined;
  } catch (error) {
    throw error;
  }
};
